import React, { useEffect } from 'react'
import Modal from 'shared/components/Modal'
import { isMobile } from 'shared/responsive-helpers'
import { STATUS_3DS_CLOSED, STATUS_3DS_FAILURE } from 'booking/constants'

const TYPE_3DS = '3ds'
const CHALLENGE_IFRAME = 'challengeIframe'

export const Secure3dFormModal = ({ onClose, translate: t, data }) => {
    useEffect(() => {
        window.addEventListener('message', messageHandler)
        return () => {
            window.removeEventListener('message', messageHandler)
        }
    }, [])

    useEffect(() => {
        sendChallengeRequest(data.challengeURL3DS, data.challengeData3DS)

        return () => {
            const element = document.getElementById('challengeIframe')
            element?.remove()
        }
    }, [])

    const createInput = (inputName, inputValue) => {
        const input = document.createElement('input')
        input.name = inputName
        input.value = inputValue
        return input
    }

    const sendChallengeRequest = (acsURL, creq) => {
        const html = document.createElement('html')
        const body = document.createElement('body')
        const challengeIframe = document.getElementById(CHALLENGE_IFRAME)

        const form = document.createElement('form')
        form.name = 'threeDSCReqForm'
        form.action = acsURL
        form.method = 'POST'
        form.target = 'challengeIframe'

        const creqInput = createInput('creq', creq)

        form.appendChild(creqInput)
        body.appendChild(form)
        html.appendChild(body)
        challengeIframe.appendChild(html)

        form.submit()
    }

    const messageHandler = message => {
        if (message?.data?.type === TYPE_3DS) {
            onModalClose(message?.data?.status)
        }
    }

    const onModalClose = type => {
        const payload = {
            type: type,
            errorMsg: type === STATUS_3DS_FAILURE && t('3ds.failure'),
        }

        onClose(payload)
    }

    return (
        <Modal
            header={t('3ds.headline')}
            size={isMobile() ? 'small' : 'large'}
            onClose={() => onModalClose(STATUS_3DS_CLOSED)}>
            <iframe width={isMobile() ? 320 : 560} height={620} id={CHALLENGE_IFRAME} name={CHALLENGE_IFRAME} />
        </Modal>
    )
}

export default withTranslate(Secure3dFormModal)
